import store from '@/store'
import { get } from 'lodash-es'
import { modelStateRegistry } from '@/utils/modelStateRegistry'
import { getPfasCategoriesColumnGroups } from './pfasCategoriesColumnGroups'
import { buildPfasCategoriesGroupDef, buildPfasCategoriesColumnDef } from './pfasCategoriesColumnsDef'
import {
  formatConstructedError,
  defaultChemicalKey,
  defaultResultKey,
  defaultResultsKey,
} from '@/utils/responseNormalizers'
import { createMetadataHelpers } from '../metadata'

const groupedKeys = get(modelStateRegistry, 'groupedModel.keys')
const namespace = 'pfasCategories'
const { getName, getDescription, getEndpointIds } = createMetadataHelpers(`${namespace}/${groupedKeys.getMetadata}`)

const getPfasCategoriesAdapter = (modelId) => ({
  [modelId]: {
    predictionsKey: `${defaultResultKey}.categories`,
    chemicalKey: defaultChemicalKey,
    errorKey: 'error',
    categoryId: 'categorizationModels',
    getResults: () => store.getters[`${namespace}/${groupedKeys.getResultsForModel}`](modelId)?.[defaultResultsKey],
    getIsLoading: () => store.getters[`${namespace}/${groupedKeys.getIsLoadingForModel}`](modelId),
    getIsAborted: () => store.getters[`${namespace}/${groupedKeys.getIsAbortedForModel}`](modelId),
    fetch: (chemicals) => store.dispatch('pfasCategories/predict', { structures: chemicals, modelId }),
    reset: () => store.commit(`${namespace}/${groupedKeys.RESET_STATE_FOR_MODEL}`, modelId),
    abort: () => store.commit(`${namespace}/${groupedKeys.ABORT_CURRENT_FETCH_FOR_MODEL}`, { modelId }),
    getParameters: () => getPfasCategoriesColumnGroups(),
    getGroupDef: buildPfasCategoriesGroupDef,
    getColumnDefBuilder: buildPfasCategoriesColumnDef,
    getName: () => getName(modelId),
    getDescription: () => getDescription(modelId),
    formatError: (error) => formatConstructedError(error),
  },
})

const getPfasCategoriesAdapters = () =>
  getEndpointIds().reduce((acc, modelId) => ({ ...acc, ...getPfasCategoriesAdapter(modelId) }), {})

export { getPfasCategoriesAdapters }
